var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('AppHeader'),_c('b-container',{attrs:{"fluid":""}},[_c('router-view')],1),_c('b-navbar',{staticClass:"mt-5",attrs:{"toggleable":"lg","type":"dark","variant":"primary"}},[_c('b-navbar-brand',{attrs:{"href":"javascript:void(0)"}},[_c('i',[_c('u',[_vm._v(_vm._s(_vm.$t('logoName')))])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }